import AxaHealthLogoMin from "../../assets/img/logo/axaHealth/axa-health-solid-stacked.svg";
import AxaHealthLogo from "../../assets/img/logo/axaHealth/axa-health-solid.svg";
import AxaHealthThriveLogo from "../../assets/img/banners/ThriveLogoAxaHealth.png";

export const LogoConstants = {
  Logo: "Logo",
  LogoMin: "LogoMin",
  LogoSet: "LogoSet",
  LogoSetMin: "LogoSetMin"
};

export const RebrandHelper = {
  names: {
    axaHealth: "AXA Health"
  },

  domainPartials: {
    axaHealth: "axahealth"
  },

  domains: {
    axaHealth: "https://www.axahealth.co.uk"
  },

  getAxaBrandName: () => {
    return RebrandHelper.names.axaHealth;
  },

  getAxaDomain: () => {
    return RebrandHelper.domains.axaHealth;
  },

  getAxaLogo: (logoType) => {
    if (
      logoType === LogoConstants.LogoMin ||
      logoType === LogoConstants.LogoSetMin
    ) {
      return AxaHealthLogoMin;
    }

    return AxaHealthLogo;
  },

  getCompanyName: () => {
    return "AXA PPP healthcare Limited";
  },

  getThriveLogo: () => {
    return AxaHealthThriveLogo;
  },
};
